/*
 * @Description: 
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2022-04-06 16:33:48
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-04-08 11:31:15
 */
const meeting = [
    {
      path: '/meeting/offline/:meetingId',
      name: 'educationDetail',
      component: () => import('../views/meeting/offline.vue'),
    },
  ]
export default meeting


// WEBPACK FOOTER //
// ./src/router/meeting.js